import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import ChangeAdd from "../Pages/Changes/ChangeAdd";
import ChangeEdit from "../Pages/Changes/ChangeEdit";
import ChangeView from "../Pages/Changes/ChangeView";
import HomePage from "../Pages/HomePage";
import IncidentAdd from "../Pages/Incidents/IncidentAdd";
import IncidentEdit from "../Pages/Incidents/IncidentEdit";
import IncidentView from "../Pages/Incidents/IncidentView";
import LoginPage from "../Pages/LoginPage";
import ProblemAdd from "../Pages/Problem/ProblemAdd";
import ProblemEdit from "../Pages/Problem/ProblemEdit";
import ProblemView from "../Pages/Problem/ProblemView";
import TaskAdd from "../Pages/Task/TaskAdd";
import TaskEdit from "../Pages/Task/TaskEdit";
import TaskView from "../Pages/Task/TaskView";
import UserManagement from "../Pages/UserManagement/UserManagement";
import RmaView from "../Pages/Rma/RmaView";
import RmaAdd from "../Pages/Rma/RmaAdd";
import RmaEdit from "../Pages/Rma/RmaEdit";
import KnowledgeBaseView from "../Pages/KnowledgeBase/KnowledgeBaseView";
import KnowledgeBaseAdd from "../Pages/KnowledgeBase/KnowledgeBaseAdd";
import ProtectedRoute from "./ProtectedRoute";
import KnowledgeBaseEdit from "../Pages/KnowledgeBase/KnowledgeBaseEdit";
import CalendarPage from "../Pages/CalendarPage";
import WorkerSchedulePage from "../Pages/Schedueler/WorkerSchedulePage";
import Delegation from "../Pages/Delegation/Delegation";
import AdminDashboard from "../Pages/Admin";
import RolesManagement from "../Pages/Managment/RolesManagment";
import ResponsiblePersonsManagement from "../Pages/Managment/ResponsiblePersons";
import SlaTable from "../Pages/Sla/SlaPage";
import AdminRequestView from "../Pages/AdminRequest/AdminRequestView";
import AdminRequestAdd from "../Pages/AdminRequest/AdminRequestAdd";
import Allupdate from "../Pages/Allupdate/Allupdate";
import ReportsPage from "../Pages/EditDropdowns/ReportsPage";
import Reporting from "../Pages/Reporting/Reporting";

const AppRouter: React.FC = () => {
  return (
    <Routes>
      {/* Public routes */}

      <Route
        path="/"
        element={
          localStorage.getItem("authToken") ? (
            <Navigate to="/home" replace />
          ) : (
            <LoginPage />
          )
        }
      />
      <Route path="/login" element={<LoginPage />} />


      {/* Protected routes */}
      <Route path="/home" element={<ProtectedRoute element={<HomePage />} />} />
      <Route
        path="/incident"
        element={<ProtectedRoute element={<IncidentView />} />}
      />
      <Route
        path="/incident-add"
        element={<ProtectedRoute element={<IncidentAdd />} />}
      />
      <Route
        path="/incident-edit/:id"
        element={<ProtectedRoute element={<IncidentEdit />} />}
      />
     <Route
        path="/usermanagement"
        element={<ProtectedRoute element={<UserManagement />} />}
      />
      <Route
        path="/problem"
        element={<ProtectedRoute element={<ProblemView />} />}
      />
      <Route
        path="/problem-add"
        element={<ProtectedRoute element={<ProblemAdd />} />}
      />
      <Route
        path="/problem-edit/:id"
        element={<ProtectedRoute element={<ProblemEdit />} />}
      />
      <Route path="/task" element={<ProtectedRoute element={<TaskView />} />} />
      <Route
        path="/task-add"
        element={<ProtectedRoute element={<TaskAdd />} />}
      />
      <Route
        path="/task-edit/:id"
        element={<ProtectedRoute element={<TaskEdit />} />}
      />
      <Route
        path="/change"
        element={<ProtectedRoute element={<ChangeView />} />}
      />
      <Route
        path="/change-add"
        element={<ProtectedRoute element={<ChangeAdd />} />}
      />
      <Route
        path="/change-edit/:id"
        element={<ProtectedRoute element={<ChangeEdit />} />}
      />
      <Route
        path="/rma-request"
        element={<ProtectedRoute element={<RmaView />} />}
      />

      <Route
        path="/rma-add"
        element={<ProtectedRoute element={<RmaAdd />} />}
      />
      <Route
        path="/rma-edit/:id"
        element={<ProtectedRoute element={<RmaEdit />} />}
      />
      <Route
        path="/knowledge-base"
        element={<ProtectedRoute element={<KnowledgeBaseView />} />}
      />
      <Route
        path="/knowledgeBase-add"
        element={<ProtectedRoute element={<KnowledgeBaseAdd />} />}
      />
      <Route
        path="/knowledgeBase-edit/:id"
        element={<ProtectedRoute element={<KnowledgeBaseEdit />} />}
      />
      <Route
        path="/calendar"
        element={<ProtectedRoute element={<CalendarPage />} />}
      />
      <Route
        path="/schedule"
        element={<ProtectedRoute element={<WorkerSchedulePage />} />}
      />
      <Route
        path="/delegation"
        element={<ProtectedRoute element={<Delegation />} />}
      />
      <Route
        path="/superadmin"
        element={<ProtectedRoute element={<AdminDashboard />} />}
      />
      <Route
        path="/roles"
        element={<ProtectedRoute element={<RolesManagement />} />}
      />
      <Route
        path="/responsiblepersons"
        element={<ProtectedRoute element={<ResponsiblePersonsManagement />} />}
      />
      <Route path="/sla" element={<ProtectedRoute element={<SlaTable />} />} />

      <Route
        path="/change"
        element={<ProtectedRoute element={<ChangeView />} />}
      />
      <Route
        path="/admin"
        element={<ProtectedRoute element={<AdminRequestView />} />}
      />
      <Route
        path="/adminRequest-add"
        element={<ProtectedRoute element={<AdminRequestAdd />} />}
      />

      <Route
        path="/update"
        element={<ProtectedRoute element={<Allupdate />} />}
      />
      <Route
        path="/reports"
        element={<ProtectedRoute element={<ReportsPage />} />}
      />
      <Route
        path="/reporting"
        element={<ProtectedRoute element={<Reporting />} />}
      />
      {/* Catch-all */}
      <Route
        path="*"
        element={
          localStorage.getItem("authToken") ? (
            <Navigate to="/home" replace />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
    </Routes>
  );
};

export default AppRouter;
